/**
 * Converts a string from snake_case to camelCase
 */
export function snakeToCamel(str: string): string {
	return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
}

/**
 * Recursively converts all keys in an object from snake_case to camelCase
 */
export function snakeObjectToCamel<T extends Record<string, any>>(obj: T): Record<string, any> {
	if (obj === null || typeof obj !== 'object') {
		return obj
	}

	if (Array.isArray(obj)) {
		return obj.map(item => snakeObjectToCamel(item))
	}

	return Object.keys(obj).reduce((result, key) => {
		const camelKey = snakeToCamel(key)
		result[camelKey] = snakeObjectToCamel(obj[key])
		return result
	}, {} as Record<string, any>)
}




/**
 * Converts a string from camelCase to snake_case
 */
export function camelToSnake(str: string): string {
	return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)
}

/**
 * Recursively converts all keys in an object from camelCase to snake_case
 */
export function camelObjectToSnake<T extends Record<string, any>>(obj: T): Record<string, any> {
	if (obj === null || typeof obj !== 'object') {
		return obj
	}

	if (Array.isArray(obj)) {
		return obj.map(item => camelObjectToSnake(item))
	}

	return Object.keys(obj).reduce((result, key) => {
		const snakeKey = camelToSnake(key)
		result[snakeKey] = camelObjectToSnake(obj[key])
		return result
	}, {} as Record<string, any>)
}

